import { userService } from './service'; // 获取角色列表数据

export function getRoutes(query) {
  return userService({
    url: 'ManagerRole/LoadData',
    method: 'get',
    params: query
  });
} // 角色新增或编辑时, 获取[授权]及[已授权的菜单主键数组]

export function AddOrModify(query) {
  return userService({
    url: 'ManagerRole/AddOrModify',
    method: 'get',
    params: query
  });
} // 删除角色

export function Delete(id) {
  return userService({
    url: 'ManagerRole/Delete?id=' + id,
    method: 'post'
  });
} // 保存数据

export function saveModifySave(obj) {
  return userService({
    url: 'ManagerRole/AddOrModifySave',
    method: 'post',
    data: obj
  });
} // 获取角色的菜单列表数据

export function LoadMenusByRoleId(roleId) {
  return userService.get('ManagerRole/LoadMenusByRoleId', {
    params: {
      roleId: roleId
    }
  });
} // 获取自定义报表授权信息列表

export function GetReportByRoleId(roleId) {
  return userService.get('ManagerRole/GetReportByRoleId', {
    params: {
      roleId: roleId
    }
  });
} // 保存自定义报表授权信息列表

export function SaveReportPermission(data) {
  return userService.post('ManagerRole/SaveReportPermission', data);
} // 获取当前角色自定义报表信息

export function GetCanShowReport() {
  return userService.get('ManagerRole/GetCanShowReport');
}